import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { useTracking } from '../../tracking/useTracking';
import { Icon } from '@zapier/design-system';
import { css } from '@emotion/react';
import { MEDIA_MAX_WIDTH } from '../../constants';
const getPaginatorBackgroundColor = (isActive, color) => {
    if (!isActive && color === '#201515') {
        return 'rgba(32, 21, 21, 0.8)';
    }
    if (!isActive && color === '#fff3e6') {
        return 'rgba(255, 253, 249, 0.8)';
    }
    return color;
};
const Styles = {
    root: css({
        maxWidth: '1170px',
        margin: '0 auto',
    }),
    carousel: css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
    }),
    button: (backgroundColor) => css({
        backgroundColor: backgroundColor,
        border: 'none',
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        cursor: 'pointer',
    }),
    previousButton: css({
        position: 'absolute',
        right: '92%',
        [MEDIA_MAX_WIDTH.small]: {
            right: '82%',
        },
    }),
    nextButton: css({
        position: 'absolute',
        left: '92%',
        [MEDIA_MAX_WIDTH.small]: {
            left: '82%',
        },
    }),
    indicator: (isActive, backgroundColor) => css({
        width: '12px',
        height: '12px',
        backgroundColor: getPaginatorBackgroundColor(isActive, backgroundColor),
        borderRadius: '50%',
        border: 'none',
        cursor: 'pointer',
        marginRight: '2px',
    }),
    pagination: css({
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        marginTop: '-60px',
        [MEDIA_MAX_WIDTH.small]: {
            marginTop: '-40px',
        },
    }),
};
export function CarouselBlock(props) {
    var _a, _b;
    const { emitUserInteractionEvent } = useTracking();
    const [activeIndex, setActiveIndex] = useState(0);
    const onPreviousClick = () => {
        setActiveIndex(activeIndex - 1);
        emitUserInteractionEvent({
            event_action: 'click',
            interaction_name: 'carousel_button_click',
            option_selected: 'previous',
        });
    };
    const onNextClick = () => {
        setActiveIndex(activeIndex + 1);
        emitUserInteractionEvent({
            event_action: 'click',
            interaction_name: 'carousel_button_click',
            option_selected: 'next',
        });
    };
    const onPaginationClick = (index) => {
        setActiveIndex(index);
        emitUserInteractionEvent({
            event_action: 'click',
            interaction_name: 'carousel_pagination_click',
        });
    };
    const isActive = (index) => {
        return index === activeIndex;
    };
    return (_jsxs("div", Object.assign({ css: Styles.root }, { children: [_jsxs("div", Object.assign({ css: Styles.carousel }, { children: [activeIndex !== 0 && (_jsx("button", Object.assign({ "data-testid": "previousButton", onClick: onPreviousClick, css: [Styles.button(props.buttonsColor), Styles.previousButton] }, { children: _jsx(Icon, { name: "arrowSmallLeft", color: props.iconColor, size: 32 }) }))), props.children && props.children[activeIndex], activeIndex < ((_a = props.children) === null || _a === void 0 ? void 0 : _a.length) - 1 && (_jsx("button", Object.assign({ "data-testid": "nextButton", onClick: onNextClick, css: [Styles.button(props.buttonsColor), Styles.nextButton] }, { children: _jsx(Icon, { name: "arrowSmallRight", color: props.iconColor, size: 32 }) })))] })), _jsx("div", Object.assign({ css: Styles.pagination }, { children: (_b = props.children) === null || _b === void 0 ? void 0 : _b.map((_child, index) => {
                    return (_jsx("button", { "aria-label": `page-${index}`, "data-testid": `indicator-${index}`, css: Styles.indicator(isActive(index), props.buttonsColor), onClick: () => onPaginationClick(index) }, index));
                }) }))] })));
}
//# sourceMappingURL=CarouselBlock.js.map